module.exports = __webpack_public_path__ + "img/Creste-Valoarea-nominala-uponline-1018x166.e935717d.png";